<template>
  <div>
    <v-dialog
      :persistent="true"
      :value="value"
      max-width="50rem"
      @input="val => $emit('input', val)">
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <v-layout>
                <v-flex>
                  <v-autocomplete
                    v-model="selectedCategoryId"
                    :disabled="categories.length === 0"
                    :items="categories"
                    :loading="loadingCategories ? 'grey' : false"
                    :rules="rules"
                    item-text="name"
                    item-value="id"
                    label="Category"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-autocomplete
                    v-model="selectedStatusId"
                    :disabled="issueStatuses.length === 0"
                    :items="issueStatuses"
                    :loading="loadingStatuses ? 'grey' : false"
                    :rules="rules"
                    item-text="name"
                    item-value="id"
                    label="Status"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="$emit('input', false)">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ack-dialog",
  props: {
    ids: {
      required: true,
      type: Array
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {

      // Known cat. / stat. to the DB
      categories: [],
      issueStatuses: [],

      loadingCategories: false,
      loadingStatuses: false,

      posting: false,

      rules: [(v) => v > 0 || "Selection cannot be empty."],

      selectedCategoryId: 0,
      selectedStatusId: 0,

      valid: false

    };
  },
  watch: {
    value (open) {
      if (open) {
        this.selectedCategoryId = 0;
        this.selectedStatusId = 0;
      }
    }
  },
  created () {
    // Get the categories
    this.loadingCategories = true;
    this.$http.
      get("/api/categories").
      then((r) => this.categories = Array.from(r.data)).
      finally(() => this.loadingCategories = false);
    // Get the statuses
    this.loadingStatuses = true;
    this.$http.
      get("/api/issue_statuses").
      then((r) => this.issueStatuses = Array.from(r.data)).
      finally(() => this.loadingStatuses = false);
  },
  methods: {
    // When the SAVE button of the edition dialog is clicked
    save () {
      this.posting = true;
      Promise.
        all(this.ids.map((id) => this.$http.put(`/api/issues/${id}`, {
          categoryId: this.selectedCategoryId,
          statusId: this.selectedStatusId
        }))).
        then(() => this.$emit("refresh")).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Issues/AckDialog.vue